var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "123.044px",
    height: "159.748px",
    viewBox: "0 0 123.044 159.748",
    enableBackground: "new 0 0 123.044 159.748",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_SEARCH"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4_SEARCH",
    display: "none"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_SEARCH"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_SEARCH"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.459,
    y: 75.037,
    transform: "matrix(0.8159 -0.5782 0.5782 0.8159 -51.8968 75.0858)",
    fill: "#FFFFFF",
    stroke: "#396A92",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    width: 7.001,
    height: 88
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#396A92",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 49.004,
    cy: 49.003,
    r: 46.999
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.6f7eeea7.svg";
export { ForwardRef as ReactComponent };